import { $Props } from '@Ravnur-Inc/core/typings/tsx';
import { Vue, prop } from 'vue-class-component';

import './live-splash-image.scss';

const CN = 'live-splash-image';

class Props {
  src = prop<string | undefined>({ default: undefined });
}

export default class LiveSplashImage extends Vue.with(Props) {
  declare $props: $Props<Props> & Partial<HTMLImageElement>;

  render() {
    const { src, $attrs } = this;
    return (
      <div class={CN} data-image={!!src} data-testid="live-splash-image">
        {src ? <img alt="Splash image" class={`${CN}__img`} src={src} {...$attrs} /> : null}
      </div>
    );
  }
}
